import axiosInstance from "../server/axios"

const token = localStorage.getItem('authToken')

export const getAchatFromClient = (id) => {
    return axiosInstance.get(`/showClientAchat/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    });
}